import React from 'react';
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';
import WhatsAppButton from '@/components/layout/WhatsAppButton';
import HeroCarousel from '@/components/home/HeroCarousel';
import CredibilitySection from '@/components/home/CredibilitySection';
import ServicesSection from '@/components/home/ServicesSection';
import ProcessSection from '@/components/home/ProcessSection';
import WhyChooseUsSection from '@/components/home/WhyChooseUsSection';
import CTASection from '@/components/home/CTASection';
import usePageTitle from '@/hooks/usePageTitle';

const HomePage = () => {
  usePageTitle("Home", "ElitePlus Solutions — Leading IT consulting and technology services company in UAE. Enterprise IT strategy, ERP advisory, cloud transformation, cybersecurity, AI automation, and digital transformation services.");
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroCarousel />
        <CredibilitySection />
        <ServicesSection />
        <ProcessSection />
        <WhyChooseUsSection />
        <CTASection />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default HomePage;
